import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { SchoolsService, School } from '_services/schools.service';
import { QuestionsService } from '_services/questions.service';
import { AuthService } from '_services/auth.service';
import { PropagateQuestionDialogComponent } from './propagate-question-dialog.component';

export interface QuestionSchoolsDialogData {
  questionLabel: string;
  questionId: string;
  schoolIds: string[];
}

@Component({
  selector: 'app-question-schools-dialog',
  templateUrl: './question-schools-dialog.component.html',
  styleUrls: ['./question-schools-dialog.component.css'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, MatSlideToggle, FormsModule, RouterLink, AsyncPipe]
})
export class QuestionSchoolsDialogComponent {
  includeDeactivated = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: QuestionSchoolsDialogData,
    private schools: SchoolsService,
    private questions: QuestionsService,
    private dialog: MatDialog,
    public auth: AuthService
  ) {}

  get aidYear(): number | null {
    return this.questions.allQuestionsLoadedAidYear;
  }

  async updateSchoolLists(): Promise<void> {
    const aidYear = this.aidYear;
    const user = await this.auth.currentUser();
    if (!aidYear || !user?.dev) {
      return;
    }
    this.dialog.open(PropagateQuestionDialogComponent, {
      width: '520px',
      data: {
        questionId: this.data.questionId,
        questionLabel: this.data.questionLabel,
        aidYear,
      },
    });
  }

  listedSchools(): School[] {
    const idSet = new Set(this.data.schoolIds);
    return this.schools.allSchools.value
      .filter(school => school.id && idSet.has(school.id))
      .filter(school => this.includeDeactivated || !school.disabledDate)
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  unknownSchoolIds(): string[] {
    const known = new Set(this.schools.allSchools.value.map(school => school.id).filter(Boolean) as string[]);
    return this.data.schoolIds.filter(id => !known.has(id)).sort();
  }
}
